import * as React from 'react';
import { RouteComponentProps, Switch } from 'react-router';

import { PrivateRoute } from 'src/router';

import { TaxListController } from './taxes/list/tax-list.controller';
import { TaxFormController } from './taxes/form/tax-form.controller';

import { RegionListController } from './regions/list/region-list.controller';
import { RegionFormController } from './regions/form/region-form.controller';

import { PlaceListController } from './places/list/place-list.controller';

import { EntitySchemaListController } from './entity-schemas/list/entity-schema-list.controller';
import { EntitySchemaFormController } from './entity-schemas/form/entity-schema-form.controller';

import { PlaceFormController } from './places/form/place-form.controller';

import { AirlineListController } from './airlines/list/airline-list.controller';
import { AirlineFormController } from './airlines/form/airline-form.controller';

import { LanguageListController } from './language/list/language-list.controller';
import { LanguageFormController } from './language/form/language-form.controller';

import { MarketListController } from './market/list/market-list.controller';
import { MarketFormController } from './market/form/market-form.controller';

import { CurrencyListController } from './currencies/list/currency-list.controller';
import { CurrencyFormController } from './currencies/form/currency-form.controller';

import { BrandListController } from './brands/list/brand-list.controller';
import { BrandFormController } from './brands/form/brand-form.controller';

import { UserListController } from './users/list/user-list.controller';
import { UserFormController } from './users/form/user-form.controller';

import { RoleListController } from './roles/list/role-list.controller';
import { RoleFormController } from './roles/form/role-form.controller';

import { DocumentTemplateCategoryListController } from './document-template-categories/list/document-template-category-list.controller';

import { DocumentTemplateListController } from './document-templates/list/document-template-list.controller';
import { DocumentTemplateFormController } from './document-templates/form/document-template-form.controller';

import { EmailDocumentTemplateListController } from './email-document-template/list/email-document-template-list.controller';
import { EmailDocumentTemplateFormController } from './email-document-template/form/email-document-template-form.controller';

import { ConfigOptionFormController } from './config-option/form/config-option-form.controller';

import { TaxonomyListController } from './taxonomies/list/taxonomy-list.controller';
import { TaxonomyFormController } from './taxonomies/form/taxonomy-form.controller';

import { ApiKeyListController } from './api-keys/api-key-list.controller';

import * as Permissions from "../permissions";
import UserTasksFullPage from 'src/app/general/user-tasks/parts/user-tasks-fullpage';
import { CacheListController } from 'src/app/general/cache/cache-result-list.controller';

export class GeneralController extends React.Component<RouteComponentProps<any>, {}> {
	render() {
		const match = this.props.match;

		return (
			<Switch>
				<PrivateRoute
					path={`${match.url}/taxes/:id`}
					component={TaxFormController}
					permissions={Permissions.taxWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/taxes`}
					component={TaxListController}
					permissions={Permissions.taxPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/regions/:id`}
					component={RegionFormController}
					permissions={Permissions.regionWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/regions`}
					component={RegionListController}
					permissions={Permissions.regionPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/places/:id/:type`}
					component={PlaceFormController}
					permissions={Permissions.placeWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/places`}
					component={PlaceListController}
					permissions={Permissions.placePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/entity-schemas/:type`}
					component={EntitySchemaFormController}
					permissions={Permissions.schemaWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/entity-schemas`}
					component={EntitySchemaListController}
					permissions={Permissions.schemaPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/airlines/:id`}
					component={AirlineFormController}
					permissions={Permissions.airlineWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/airlines`}
					component={AirlineListController}
					permissions={Permissions.airlinePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/language/:id`}
					component={LanguageFormController}
					permissions={Permissions.languageWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/language`}
					component={LanguageListController}
					permissions={Permissions.languagePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/market/:id`}
					component={MarketFormController}
					permissions={Permissions.marketWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/market`}
					component={MarketListController}
					permissions={Permissions.marketPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/currencies/:id`}
					component={CurrencyFormController}
					permissions={Permissions.currencyWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/currencies`}
					component={CurrencyListController}
					permissions={Permissions.currencyPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/brands/:id`}
					component={BrandFormController}
					permissions={Permissions.brandWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/brands`}
					component={BrandListController}
					permissions={Permissions.brandPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/users/:id`}
					component={UserFormController}
					permissions={Permissions.userWritePermission.concat(Permissions.profilePermission)}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/users`}
					component={UserListController}
					permissions={Permissions.userPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/roles/:id`}
					component={RoleFormController}
					permissions={Permissions.userWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/roles`}
					component={RoleListController}
					permissions={Permissions.userPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/document-template-categories`}
					component={DocumentTemplateCategoryListController}
					permissions={Permissions.docTemplateCategoryPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/document-templates/:id`}
					component={DocumentTemplateFormController}
					permissions={Permissions.docTemplateWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/document-templates`}
					component={DocumentTemplateListController}
					permissions={Permissions.docTemplatePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/email-document-templates/:id`}
					component={EmailDocumentTemplateFormController}
					permissions={Permissions.emailTemplateWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/email-document-templates`}
					component={EmailDocumentTemplateListController}
					permissions={Permissions.emailTemplatePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/config-option`}
					component={ConfigOptionFormController}
					permissions={Permissions.configPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/taxonomies/:id`}
					component={TaxonomyFormController}
					permissions={Permissions.taxonomyWritePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/taxonomies`}
					component={TaxonomyListController}
					permissions={Permissions.taxonomyPermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/usertasks`}
					component={UserTasksFullPage}
					kanban={true}
					permissions={Permissions.userTasksPermissions}
					{...this.props}
				/>

				<PrivateRoute
					path={`${match.url}/cache`}
					component={CacheListController}
					kanban={true}
					permissions={Permissions.rulePermission}
					{...this.props}
				/>
				<PrivateRoute
					path={`${match.url}/api-keys`}
					component={ApiKeyListController}
					permissions={Permissions.apiKeyPermission}
					{...this.props}
				/>
			</Switch>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/general.controller.tsx